var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7, _ellipse3, _ellipse4, _path8, _path9, _ellipse5, _ellipse6, _path10, _path11, _ellipse7, _path12, _ellipse8, _path13, _path14, _ellipse9, _path15, _ellipse10, _path16, _path17, _ellipse11, _path18, _ellipse12, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRedemptionConfigBanner = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 117,
    viewBox: "0 0 166 117",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4621 41.5963L59.6912 25.9208C60.6643 25.399 61.8175 25.3311 62.845 25.7353L147.433 59.0045C149.366 59.7646 150.317 61.9477 149.556 63.8805L131.388 110.075C130.628 112.008 128.445 112.959 126.512 112.198L41.886 78.9145C40.8801 78.5188 40.0931 77.7095 39.7257 76.6929L28.7027 46.1884C28.0684 44.4332 28.8174 42.4783 30.4621 41.5963ZM38.5898 53.6539C40.9046 54.5643 43.5192 53.4258 44.4296 51.111C45.3401 48.7962 44.2016 46.1816 41.8868 45.2712C39.572 44.3608 36.9574 45.4992 36.0469 47.8141C35.1365 50.1289 36.275 52.7435 38.5898 53.6539Z",
    fill: "#5D5CF5",
    fillOpacity: 0.49
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8105 1L69.8105 19.4653",
    stroke: "#F8D49D",
    strokeWidth: 1.21677,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4485 1.8793L72.4485 15.0688",
    stroke: "#F2AE43",
    strokeWidth: 1.21677,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.81 3.63791L120.81 20.3446",
    stroke: "#F2AE43",
    strokeWidth: 1.21677,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.448 10.6723L123.448 22.9825",
    stroke: "#F2AE43",
    strokeWidth: 1.21677,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.31055,
    cy: 7.96818,
    rx: 8.31055,
    ry: 7.96818,
    transform: "matrix(0.887576 0.46066 -0.441816 0.897106 117.114 86.3872)",
    fill: "#EBBC73"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.31055,
    cy: 7.96818,
    rx: 8.31055,
    ry: 7.96818,
    transform: "matrix(0.887576 0.46066 -0.441816 0.897106 118.028 85.102)",
    fill: "#F8D49D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.013 99.3446C126.379 102.663 122.262 103.936 118.8 102.139C115.338 100.342 113.896 96.1837 115.53 92.8656C117.164 89.5474 121.282 88.2746 124.743 90.0712C128.205 91.8678 129.648 96.0265 128.013 99.3446Z",
    stroke: "#F4B85B",
    strokeWidth: 0.811179
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.34 97.6425L119.672 95.1339L118.507 92.1215L122.032 93.2391L124.995 91.5168L124.57 94.9122L127.135 97.1705L123.776 97.8299L122.401 100.96L120.749 97.9678L117.34 97.6425Z",
    fill: "#F2AE43"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.31055,
    cy: 7.96818,
    rx: 8.31055,
    ry: 7.96818,
    transform: "matrix(0.887576 0.46066 -0.441816 0.897106 53.9897 79.6636)",
    fill: "#EBBC73"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.31055,
    cy: 7.96818,
    rx: 8.31055,
    ry: 7.96818,
    transform: "matrix(0.887576 0.46066 -0.441816 0.897106 54.9041 78.3784)",
    fill: "#F8D49D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8892 92.6211C63.255 95.9392 59.1375 97.212 55.6758 95.4154C52.2142 93.6188 50.7716 89.4601 52.4057 86.142C54.0399 82.8239 58.1574 81.5511 61.6191 83.3477C65.0807 85.1443 66.5233 89.3029 64.8892 92.6211Z",
    stroke: "#F4B85B",
    strokeWidth: 0.811179
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2161 90.919L56.5479 88.4104L55.383 85.398L58.9074 86.5156L61.8711 84.7933L61.4453 88.1887L64.0103 90.4469L60.6518 91.1064L59.2769 94.2368L57.6248 91.2442L54.2161 90.919Z",
    fill: "#F2AE43"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.3307,
    cy: 24.0088,
    rx: 12.4337,
    ry: 10.3614,
    fill: "#EBBC73"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.3307,
    cy: 22.6283,
    rx: 12.4337,
    ry: 10.3614,
    fill: "#F8D49D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2712 24.4713L71.2222 21.5916L70.1861 17.447L74.367 19.2465L78.4308 17.7951L77.2697 21.859L80.1725 24.0893L75.8723 24.8094L73.9797 28.465L72.6253 24.8094L68.2712 24.4713Z",
    fill: "#F2AE43"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9772 22.6273C84.9772 27.2881 80.2933 31.2016 74.3305 31.2016C68.3678 31.2016 63.6839 27.2881 63.6839 22.6273C63.6839 17.9664 68.3678 14.0529 74.3305 14.0529C80.2933 14.0529 84.9772 17.9664 84.9772 22.6273Z",
    stroke: "#F4B85B",
    strokeWidth: 0.811179
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.196,
    cy: 61.5566,
    rx: 3.93651,
    ry: 12.3148,
    transform: "rotate(56.2306 134.196 61.5566)",
    fill: "#EBBC73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.123 65.5135L124.234 68.6802L144.641 54.958L142.178 51.7914L122.123 65.5135Z",
    fill: "#EBBC73"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.637,
    cy: 59.1194,
    rx: 3.93651,
    ry: 12.3148,
    transform: "rotate(56.2306 132.637 59.1194)",
    fill: "#F8D49D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.515 57.0372L133.053 57.0372L136.47 55.3102L135.519 57.6346L137.317 58.4949L133.754 59.7904L132.195 62.2815L131.223 60.6621L127.924 61.7338L130.515 58.8188L130.515 57.0372Z",
    fill: "#F2AE43"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134.009 61.5166C131.551 63.16 129.134 64.3309 127.22 64.9019C126.261 65.1881 125.452 65.3166 124.837 65.2914C124.212 65.2657 123.879 65.0876 123.73 64.8636C123.58 64.6396 123.542 64.2637 123.757 63.6764C123.969 63.0992 124.397 62.4 125.028 61.6229C126.287 60.0728 128.292 58.2859 130.75 56.6426C133.208 54.9992 135.625 53.8283 137.539 53.2573C138.498 52.9711 139.308 52.8426 139.922 52.8678C140.547 52.8935 140.88 53.0717 141.03 53.2956C141.179 53.5196 141.217 53.8955 141.002 54.4828C140.79 55.06 140.362 55.7592 139.731 56.5363C138.473 58.0864 136.467 59.8733 134.009 61.5166Z",
    stroke: "#F4B85B",
    strokeWidth: 0.811179
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.6655,
    cy: 78.5929,
    rx: 3.53332,
    ry: 11.0534,
    transform: "rotate(124.152 84.6655 78.5929)",
    fill: "#EBBC73"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3016 69.8853L75.38 72.7096L93.6786 85.0538L95.4815 81.9368L77.3016 69.8853Z",
    fill: "#EBBC73"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.1655,
    cy: 76.4739,
    rx: 3.53332,
    ry: 11.0534,
    transform: "rotate(124.152 86.1655 76.4739)",
    fill: "#F8D49D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1827 74.006L88.0389 76.1165L90.6283 78.3762L88.374 78.3694L88.2649 80.1549L85.9854 77.6288L83.3873 77.172L84.4064 75.8175L82.4021 73.4356L85.7009 74.6071L87.1827 74.006Z",
    fill: "#F2AE43"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.657 78.3903C82.4634 76.9022 80.6772 75.2891 79.56 73.8943C78.9998 73.1948 78.6228 72.5688 78.4387 72.0555C78.251 71.5321 78.2913 71.211 78.4161 71.0271C78.5408 70.8432 78.8243 70.6871 79.38 70.668C79.925 70.6492 80.646 70.7681 81.503 71.03C83.212 71.5525 85.3712 72.6158 87.5648 74.1038C89.7584 75.5919 91.5446 77.205 92.6618 78.5998C93.2221 79.2993 93.599 79.9253 93.7831 80.4386C93.9708 80.962 93.9305 81.2831 93.8058 81.467C93.681 81.6509 93.3976 81.807 92.8418 81.8261C92.2969 81.8449 91.5758 81.726 90.7188 81.4641C89.0098 80.9416 86.8506 79.8783 84.657 78.3903Z",
    stroke: "#F4B85B",
    strokeWidth: 0.811179
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.232,
    cy: 22.9727,
    rx: 2.94611,
    ry: 9.21644,
    transform: "rotate(-36.0027 121.232 22.9727)",
    fill: "#EBBC73"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M124.543 31.8851L126.85 30.214L115.992 15.3528L113.696 17.2871L124.543 31.8851Z",
    fill: "#EBBC73"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.456,
    cy: 24.2092,
    rx: 2.94611,
    ry: 9.21644,
    transform: "rotate(-36.0027 119.456 24.2092)",
    fill: "#F8D49D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.96 25.8552L117.886 23.9576L116.495 21.4524L118.261 22.0958L118.852 20.7264L119.925 23.3528L121.833 24.4465L120.65 25.2204L121.548 27.6559L119.293 25.8032L117.96 25.8552Z",
    fill: "#F2AE43"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M121.127 23.1741C122.423 24.9582 123.364 26.723 123.843 28.1252C124.083 28.8288 124.199 29.4185 124.198 29.8628C124.197 30.3178 124.077 30.5312 123.952 30.6214C123.828 30.7116 123.588 30.7602 123.155 30.6206C122.732 30.4842 122.207 30.1916 121.612 29.7459C120.427 28.8574 119.039 27.4177 117.742 25.6336C116.446 23.8495 115.505 22.0847 115.027 20.6824C114.786 19.9789 114.67 19.3891 114.671 18.9449C114.672 18.4898 114.793 18.2765 114.917 18.1863C115.041 18.096 115.281 18.0474 115.714 18.1871C116.137 18.3234 116.662 18.616 117.257 19.0618C118.443 19.9502 119.831 21.39 121.127 23.1741Z",
    stroke: "#F4B85B",
    strokeWidth: 0.811179
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M143.164 64.1938L126.993 105.936",
    stroke: "#AAC3FF",
    strokeWidth: 1.07476,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1923 31.4759L48.022 75.8503",
    stroke: "#AAC3FF",
    strokeWidth: 1.07476,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M110.824 37.8711L106.879 36.5958C105.577 33.006 111.373 31.7118 110.071 28.0937L114.016 29.369C115.318 32.9872 109.522 34.2814 110.824 37.8711Z",
    fill: "#9EA4FA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1489 18.5747L52.5045 21.3338C49.3693 21.7755 49.184 17.2558 46.035 17.6831L47.6706 14.9266C50.8196 14.4993 51.0049 19.0191 54.1489 18.5747Z",
    fill: "#29C855"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6129 93.3786L35.5824 89.9463C37.499 86.8446 41.2739 89.9088 43.2122 86.8051L44.2469 90.2278C42.3086 93.3314 38.5337 90.2673 36.6129 93.3786Z",
    fill: "#F4AE72"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M151.893 94.8512L151.588 89.9132C155.29 86.7023 159.46 92.4917 163.162 89.2808L163.428 94.2775C159.754 97.4219 155.595 91.6403 151.893 94.8512Z",
    fill: "#F2AE43"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6562 48.8385C40.1801 48.9025 40.5552 49.3797 40.4651 49.8997C39.7675 53.9252 37.7958 57.6306 34.8278 60.4626C31.6289 63.5149 27.4707 65.3636 23.0615 65.6937C18.6524 66.0238 14.2652 64.8149 10.6475 62.273C7.02972 59.731 4.40529 56.0133 3.22134 51.7533C2.03739 47.4933 2.36717 42.9545 4.15449 38.9104C5.9418 34.8663 9.07608 31.567 13.0233 29.5747C16.9704 27.5824 21.4863 27.0204 25.8014 27.9844C29.805 28.8788 33.4059 31.0355 36.0806 34.1237C36.4261 34.5227 36.351 35.125 35.9353 35.4502C35.5196 35.7753 34.921 35.6999 34.5733 35.3029C32.1726 32.562 28.9567 30.6475 25.3848 29.8495C21.5012 28.9819 17.4369 29.4877 13.8844 31.2808C10.3319 33.0739 7.51109 36.0432 5.9025 39.6829C4.29391 43.3227 3.99711 47.4075 5.06267 51.2416C6.12823 55.0756 8.49021 58.4215 11.7462 60.7093C15.0021 62.997 18.9506 64.085 22.9188 63.7879C26.8871 63.4908 30.6295 61.827 33.5085 59.0799C36.1565 56.5532 37.9234 53.254 38.5655 49.6674C38.6585 49.1479 39.1324 48.7744 39.6562 48.8385Z",
    fill: "#F7D443"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6708 56.3172L68.8562 77.6198L108.007 93.3566L115.822 72.054L76.6708 56.3172Z",
    fill: "#F2AE43"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M86.4133 59.8119L78.344 82.2112L85.2948 85.0616L93.3641 62.6623L86.4133 59.8119Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M102.381 65.7547L94.429 87.8454L107.869 93.3557L115.821 71.265L102.381 65.7547Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3186 52.7498L76.0776 55.7729L116.615 71.9691L117.856 68.946L77.3186 52.7498Z",
    fill: "#E1A038"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M87.8562 56.8645L86.604 60.0762L93.2597 62.877L94.5118 59.6653L87.8562 56.8645Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M103.609 63.0036L102.364 66.1214L116.597 71.968L117.842 68.8502L103.609 63.0036Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M106.61 59.9072C106.964 59.0042 106.914 57.9729 106.47 57.0403C106.027 56.1076 105.226 55.3498 104.244 54.9336L109.667 57.2174C110.154 57.4227 110.603 57.7143 110.986 58.0757C111.37 58.437 111.682 58.861 111.903 59.3233C112.124 59.7857 112.251 60.2774 112.277 60.7704C112.302 61.2633 112.225 61.7479 112.05 62.1965C111.876 62.645 111.607 63.0488 111.259 63.3846C110.911 63.7204 110.491 63.9818 110.023 64.1538C109.555 64.3258 109.048 64.405 108.53 64.387C108.013 64.369 107.496 64.254 107.008 64.0487L103.295 62.4853L101.604 61.7651C102.585 62.1706 103.661 62.2028 104.599 61.8548C105.537 61.5068 106.26 60.8067 106.61 59.9072Z",
    fill: "#DA9D3C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M104.313 55.0995L109.728 57.3749C109.241 57.1702 108.724 57.0556 108.208 57.0376C107.691 57.0196 107.185 57.0985 106.717 57.27C106.249 57.4414 105.83 57.702 105.482 58.0368C105.135 58.3716 104.867 58.7741 104.692 59.2212L103.365 62.6252L97.9572 60.323L99.2848 56.919C99.6411 56.022 100.37 55.3269 101.313 54.9858C102.255 54.6448 103.334 54.6856 104.313 55.0995Z",
    fill: "#F2AE43"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6015 52.8877L93.1738 50.5651C94.16 50.9829 94.9654 51.7443 95.4133 52.6823C95.8613 53.6203 95.9152 54.6584 95.5633 55.5688L94.2313 59.001L99.659 61.3236L100.991 57.8914C101.166 57.4407 101.243 56.9538 101.218 56.4583C101.192 55.9629 101.065 55.4687 100.843 55.004C100.621 54.5394 100.309 54.1133 99.9246 53.7502C99.5399 53.387 99.0903 53.094 98.6015 52.8877Z",
    fill: "#DA9D3C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M93.638 54.9111C93.9916 54.0061 94.721 53.3029 95.6662 52.9556C96.6114 52.6084 97.6953 52.6456 98.6801 53.059L93.2649 50.7485C92.2802 50.3339 91.1957 50.2961 90.2502 50.6435C89.3046 50.9908 88.5753 51.6948 88.2228 52.6006C87.8702 53.5065 87.9233 54.5399 88.3703 55.4736C88.8173 56.4073 89.6217 57.1648 90.6064 57.5794L94.3192 59.1427L96.0115 59.8574C95.0373 59.4405 94.2423 58.688 93.7981 57.7625C93.354 56.8369 93.2965 55.8127 93.638 54.9111Z",
    fill: "#F2AE43"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedemptionConfigBanner, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/redemption-config-banner.fa326a7c.svg";
export { ForwardRef as ReactComponent };